import React, { FC } from "react";
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalManager,
  ModalTitle,
} from "src/components/Modal";
import { Text } from "src/components/Text";
import { useTranslation } from "src/hooks/useTranslation";
import { Button } from "src/components/Button";

type Props = {
  setShowDrawer: (showDrawer: boolean) => void;
  showDrawer: boolean;
};

export const PaymentMenthodsVirtualAccountDrawer: FC<Props> = ({
  showDrawer,
  setShowDrawer,
}) => {
  const translate = useTranslation();

  return (
    <ModalManager
      modalSize="m"
      showModal={showDrawer}
      onClose={() => setShowDrawer(false)}
    >
      <Modal>
        <ModalHeader hideCloseIcon>
          <ModalTitle>
            {translate(
              "payment_methods.basic_package.virtual_account.modal.title"
            )}
          </ModalTitle>
        </ModalHeader>
        <ModalContent>
          <Text>
            {translate(
              "payment_methods.basic_package.virtual_account.modal.content"
            )}
          </Text>
        </ModalContent>
        <ModalFooter>
          <Button onClick={() => setShowDrawer(false)}>
            {translate(
              "payment_methods.basic_package.virtual_account.modal.cta"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
